import apiClient from "./client";

async function parseResponse(res) {
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function getObjectiveStatusComments(objectiveId, boardAccessToken) {
  return parseResponse(await apiClient.get(`/api/objectives/${objectiveId}/status-comments`, { token: boardAccessToken }));
}

export async function createObjectiveStatusComment(objectiveId, comment) {
  const res = await apiClient.post(`/api/objectives/${objectiveId}/status-comments`, { comment });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function updateObjectiveStatusComment(objectiveId, commentId, comment) {
  const res = await apiClient.patch(`/api/objectives/${objectiveId}/status-comments/${commentId}`, { comment });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function getKeyResultStatusComments(krId, boardAccessToken) {
  return parseResponse(await apiClient.get(`/api/key-results/${krId}/status-comments`, { token: boardAccessToken }));
}

export async function createKeyResultStatusComment(krId, comment) {
  const res = await apiClient.post(`/api/key-results/${krId}/status-comments`, { comment });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function updateKeyResultStatusComment(krId, commentId, comment) {
  const res = await apiClient.patch(`/api/key-results/${krId}/status-comments/${commentId}`, { comment });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}
